import consumer from '../../';

const RidersLocationChannel = consumer.subscriptions.create(
  'RidersLocationChannel'
);

export default RidersLocationChannel;
